var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.content.data.intro.visible)?_c('Intro'):_vm._e(),(_vm.content.data.about.visible)?_c('About'):_vm._e(),(_vm.content.data.hero_pack.visible)?_c('BeeHeroPack'):_vm._e(),(_vm.content.data.teasers.visible)?_c('Teaser'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }